<template>
  <div class="detail-list-box content-revision-box" :class="{ 'missed-opportunity-class': links.missed_opportunities }">
    <b-card no-body>
      <div class="top-bar">
        <div class="icon-box">
          <i class="fas fa-times" @click="closeOrderSidebar"></i>
        </div>
      </div>
      <b-tabs v-model="tabIndex" card>
        <b-tab title="Details">
          <b-card-text>
            <div class="content-box-style_body">
              <div class="detail-table-box">
                <table>
                  <tr>
                    <td>
                      <div class="text-1">
                        Order ID<span>{{ this.links.order_id }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-1">
                        Link ID <span>{{ this.links.id }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-1">
                        Status <span>{{ this.links.status }}</span>
                      </div>
                    </td>
                    <td>  
                      <div class="text-1">
                        DA/DR<span>{{ isMediaPlacementLink(this.links) ? getMediaDaLabel(this.links) : (this.links.product_name || '') }}</span>
                      </div>
                    </td>
                    <!-- <td v-if="this.links.missed_opportunities">
                      <div class="text-1 dr-text" style="width: 40px;">
                        DR<span>{{ this.links.exact_dr }}</span>
                      </div>
                    </td> -->
                  </tr>
                  <tr>
                    <td v-if="this.links.missed_opportunities">
                      <div class="text-1">
                        Live DA
                        <span>{{ this.links.domain_authority }}</span>
                      </div>
                    </td>
                    <td v-else>
                      <div class="text-1">
                        Domain Authority
                        <span>{{ this.links.domain_authority }}</span>
                      </div>
                    </td>
                    <!-- <td v-if="this.links.missed_opportunities">
                      <div class="text-1">
                        Live DR <span>{{ this.links.domain_rating }}</span>
                      </div>
                    </td> -->
                    <td>
                      <div class="text-1">
                        Spam Score <span>{{ this.links.spam_score }}</span>
                      </div>
                    </td>
                    <td v-if="!this.links.missed_opportunities && !this.links.media_placement && !isBrandMention">
                      <div class="text-1">
                        Do Follow <span>{{ this.links.do_follow }}</span>
                      </div>
                    </td>
                    <td v-if="this.links.media_placement">
                      <div class="text-1">
                        Industry <span>{{  this.links.industry}}</span>
                      </div>
                    </td>
                    <td v-if="this.links.missed_opportunities || this.links.media_placement">
                      <div class="text-1">
                        Traffic <span>{{ commaSeperatedValue(this.links.traffic) }}</span>
                      </div>
                    </td>
                    <td v-if="this.links.missed_opportunities">
                      <div class="text-1">
                        DA Date <span>{{ this.links.da_dr_date }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div v-if="this.links.media_placement" class="text-1">
                        Type of Website<span>{{
                          this.links.type_of_website
                        }}</span>
                      </div>
                      <div v-else-if="isBrandMention" class="text-1">
                        Placement Type<span>{{ this.links.placement_type }}</span>
                      </div>
                      <div v-else class="text-1">
                        Primary Category<span>{{
                          this.links.primary_category
                        }}</span>
                      </div>
                    </td>
                    <td colspan="1" v-if="this.links.media_placement">
                      <div class="text-1">
                        Rel Attribute<span>{{
                          this.links.rel_attribute
                        }}</span>
                      </div>
                    </td>
                    <td colspan="1" v-if="this.links.media_placement">
                      <div class="text-1">
                        Sponsored Tag<span>{{
                          this.links.sponsored_tag
                        }}</span>
                      </div>
                    </td>
                    <td v-if="this.links.media_placement">
                      <div class="text-1">
                        Location <span>{{  this.links.location}}</span>
                      </div>
                    </td>
                    <td colspan="1" v-if="isBrandMention">
                      <div class="text-1">
                        Link Type
                        <span>{{ this.links.link_type || this.links.do_follow }}</span>
                      </div>
                    </td>
                    <td colspan="1" v-if="isBrandMention">
                      <div class="text-1">
                        Hyper Link
                        <span>{{ includeHyperlinkLabel }}</span>
                      </div>
                    </td>
                    <td colspan="1" v-else-if="this.links.secondary_category">
                      <div class="text-1">
                        Secondary Category
                        <span>{{ this.links.secondary_category }}</span>
                      </div>
                    </td>
                    <td v-if="this.links.missed_opportunities">
                      <div class="text-1">
                        Do Follow <span>{{ this.links.do_follow }}</span>
                      </div>
                    </td>
                    <td v-if="this.links.missed_opportunities">
                      <div class="text-1">
                        Order Type <span>{{ this.links.mo_order_type }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="text-1">
                        Placement URL<span class="destination-link-text">{{
                          this.links.placement_authority
                        }}</span>
                      </div>
                    </td>
                    <td colspan="2">
                      <div class="text-1">
                        Publish date <span>{{ this.links.publish_date }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="text-1">
                        Destination URL<span class="destination-link-text">{{
                          this.links.destination_link
                        }}</span>
                      </div>
                    </td>
                    <td colspan="2">
                      <div class="text-1">
                        {{ isBrandMention ? 'Brand Website' : 'Anchor Text:' }} <span>{{ isBrandMention ? this.links.brand_website : this.links.anchor_text }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="brand-brief-row" v-for="(briefRow, rowIndex) in brandBriefRows" :key="`brief-row-${rowIndex}`">
                    <td
                      colspan="2"
                      v-for="(field, fieldIndex) in briefRow"
                      :key="`brief-${rowIndex}-${fieldIndex}`"
                    >
                      <div class="text-1">
                        {{ field.label }} <span class="brand-brief-text">{{ field.value }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <div class="text-1">
                        Live URL<span class="bText">{{
                          this.links.live_link
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <template v-if="!this.links.packageOrder">
                    <tr class="addon-text" v-if="displayAddons.length">
                      <td><span>Add-Ons</span></td>
                    </tr>
                    <tr class="addon-bg-box" v-for="(addonRow, rowIndex) in addonRows" :key="`addon-row-${rowIndex}`">
                      <td
                        colspan="1"
                        v-for="(addon, addonIndex) in addonRow"
                        :key="`addon-${rowIndex}-${addonIndex}`"
                      >
                        <div class="text-1">
                          {{ addon.name }}<span>{{ addon.value }}</span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title="Message" v-if="!showOnlyDetail" @click="messageRead(this.links.id)">
          <b-card-text>
            <div class="content-box-style_body">
              <div class="message-box link-detail-message-box">
                <div class="recent-box-sec" v-if="messages.length > 0">
                  <div class="link-detail-message-list">
                    <div
                      class="link-detail-message-item"
                      v-for="recentMessage in messages"
                      :key="recentMessage.link_id"
                    >
                      <div class="link-detail-message-header">
                        <div class="link-detail-message-name">
                          {{ recentMessage.name }}
                        </div>
                        <span class="link-detail-message-date">{{ recentMessage.date }}</span>
                      </div>
                      <div
                        class="link-detail-message-text"
                        v-html="recentMessage.message"
                      ></div>
                    </div>
                  </div>
                </div>
                <vue-editor
                  v-model="data.message"
                  :editorToolbar="customToolbar"
                ></vue-editor>
                <span
                  v-if="errors.message"
                  class="invalid-feedback"
                  style="display: block"
                  role="alert"
                >
                  <strong>{{
                    data.message.length > 0 ? "" : errors.message[0]
                  }}</strong>
                </span>
                <div class="btn-box">
                  <a class="btn-1" @click="sendMessage(this.links.id)">Send</a>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <!-- <template v-if="estimatedArticleRequest"> -->
          <b-tab title="Content" v-if="!showOnlyDetail && (activeLink.article_current_status == 'Rejected' || activeLink.status == 'Pending Review')">
            <b-card-text>
              <div class="content-box-style_body">
                <div class="content-box">
                  <div
                    class="btn-box"
                    v-if="activeLink.status == 'Pending Review' && activeLink.article_current_status != 'Request Pending'"
                  >
                    <a href="javascript:;" v-b-modal.modal-box-3>Revision</a>
                    <a
                      href="javascript:;"
                      class="green-btn"
                      @click="approve(activeLink.id)"
                      >Approve</a
                    >
                  </div>
                  <template v-if="estimatedArticleRequest.status == 'Rejected' || estimatedArticleRequest.status == 'Required Content Approval'">
                      <ul class="mt-2">
                        <li>
                          <img src="@/assets/common/images/docx.png" />
                          Content file - {{ estimatedArticleRequest.link_id }}
                        </li>
                        <li>Uploaded on: {{ estimatedArticleRequest.uploaded_on }}</li>
                        <li>Status: {{ estimatedArticleRequest.status == 'Rejected' ? 'Revision' : 'Available' }}</li>
                        <li v-if="estimatedArticleRequest.status == 'Required Content Approval'">
                          <a
                          class="green-btn"
                            v-if="isGoogleDocArticle"
                            href="javascript:;"
                            @click="viewFile()"
                          >
                            View
                          </a>
                          <a
                            v-else
                            href="javascript:;"
                            @click="
                              download(estimatedArticleRequest.article_id)
                            "
                          >
                            <img
                              src="@/assets/common/images/cloud-computing.png"
                          /></a>
                        </li>
                      </ul>
                  </template>
                </div>
              </div>
            </b-card-text>
          </b-tab>
      <!-- </template> -->
      </b-tabs>
    </b-card>

    <b-modal
      id="modal-box-3"
      class="rivision-modal-box"
      centered
      title="Request For Article Revision"
      :no-close-on-backdrop="true"
    >
      <form>
        <b-row>
          <b-col md="12">
            <div class="form-group">
              <label>Revision Reason</label>
              <b-form-select
                id="input-3"
                v-model="contentData.reason_id"
                required
              >
                <option value="null">Please select an option</option>
                <option v-for="(pd, k) in reasons" :key="k" :value="pd.id">
                  {{ pd.reason }}
                </option>
              </b-form-select>
              <span
                v-if="errors.reason"
                class="required-text invalid-feedback"
                style="display: block"
                role="alert"
              >
                <strong>{{
                  contentData.reason_id == null ||
                  contentData.reason_id == "null"
                    ? errors.reason
                    : ""
                }}</strong>
              </span>
            </div>
          </b-col>
          <b-col md="12">
            <div class="form-group">
              <label>Detail</label>
              <b-form-textarea
                id="input-6"
                v-model="contentData.additional_details"
                type="text"
                rows="5"
                required
              ></b-form-textarea>
              <span
                v-if="errors.additional_details"
                class="required-text invalid-feedback"
                style="display: block"
                role="alert"
              >
                <strong>{{
                  contentData.additional_details.length > 0
                    ? ""
                    : errors.additional_details
                }}</strong>
              </span>
            </div>
          </b-col>
          <b-col md="12">
            <div class="btn-box-list">
              <a href="javascript:;" @click="revision(this.links.id)" class="btn-1"
                >Send
              </a>
            </div>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import { VueEditor } from "vue3-editor";
import { commaSeperatedValue } from "@/prod.js";
// import jquery from "jquery";
export default {
  props: ["activeLink", "reasons", "showOnlyDetail"],
  watch: {
    activeLink() {
      this.links = this.activeLink;
      this.linkId = this.links.id;
      this.messages = this.links.messages ? this.links.messages : "";
      // this.estimatedArticleRequest = this.links.estimatedArticleRequest ? this.links.estimatedArticleRequest : "";
      if(this.links.estimatedArticleRequest){
        this.estimatedArticleRequest = this.links.estimatedArticleRequest;
        this.contentTab.filename = this.estimatedArticleRequest.file_name;
        this.contentTab.path = this.estimatedArticleRequest.path || "";
      }else{
        this.estimatedArticleRequest = "";
        this.contentTab.filename = "";
        this.contentTab.path = "";
      }
      this.count = this.links.counts;
      this.count = --this.count;
    },
    linkId: function(newVal) {
      if (newVal !== "" && this.tabIndex == 1) {
        this.$nextTick(function() {
          this.messageRead(newVal);
        });
      }
    }
  },
  components: {
    VueEditor,
  },
  mounted() {
    var tabVal = location.search.replace("?tab=", "");
    this.tabIndex = 0;
    if (tabVal) {
      if (tabVal == "message" || tabVal == "content") {
        this.tabSelected(tabVal);
      }
    }
  },
  data() {
    return {
      customToolbar: [["bold", "italic"]],
      messages: [],
      estimatedArticleRequest: [],
      links: [],
      linkId: '',
      revision_check: false,
      count: "",
      recent_messages: "",
      contentData: {
        additional_details: "",
        reason_id: null,
      },
      data: {
        message: "",
      },
      errors: [],
      tabIndex: 2,
      contentTab: {
        filename: '',
        path: '',
        link_id: '',
        uploaded_on: '',
        status: '',
        article_id: '',
      },
      messageAlreadyRead: false,
      daDrDisplay: '',
      commaSeperatedValue,
    };
  },
  methods: {
    formatTrafficStabilityValue(value) {
      const raw = String(value || "").trim();
      if (!raw) return raw;
      if (/\b12\b/i.test(raw)) {
        return raw.replace(/12\s*month\s*stable\s*traffic/gi, "12mo");
      }
      if (/\b6\b/i.test(raw)) {
        return raw.replace(/6\s*month\s*stable\s*traffic/gi, "6mo");
      }
      return raw;
    },
    formatLessThanValue(value) {
      const raw = String(value || "").trim();
      if (!raw) return raw;
      return raw.replace(/less\s*than\s*/gi, "< ");
    },
    formatAddonValue(addon) {
      const name = String(addon?.name || "").trim().toLowerCase();
      const value = String(addon?.value || "").trim();
      if (!value) return value;
      if (name === "traffic stability") {
        return this.formatTrafficStabilityValue(value);
      }
      if (name === "spam score") {
        return this.formatLessThanValue(value);
      }
      return value;
    },
    tabSelected(tab) {
      if (tab === "message") {
        this.tabIndex = 1;
      } else if (tab === "content") {
        this.tabIndex = 2;
      }
    },
    closeOrderSidebar() {
      this.$emit("closeOrderSidebar");
    },
    isMediaPlacementLink(link) {
      return (
        link?.media_placement === true ||
        link?.media_link === true ||
        Number(link?.media_placement_id) > 0
      );
    },
    getMediaDaLabel(link) {
      const value = link?.exact_da ?? link?.exact_da_dr ?? link?.authority;
      return value != null && String(value).trim() !== "" ? `DA ${value}` : "";
    },
    async sendMessage(id) {
      this.errors = [];
      this.data["id"] = id;
      this.$parent.loading = true;
      try {
        let res = await this.$store.dispatch(
          "Link/sendMessageDataAction",
          this.data,
          {
            root: true,
          }
        );
        if (res.success) {
          this.$parent.loading = false;
          this.messages = res.data;
          this.data.message = "";
          toast.success(res.message, { timeout: 3000 });
        }
      } catch (error) {
        this.$parent.loading = false;
        this.errors["message"] = error.response.data.errors.message;
      }
    },

    isGoogleDocLink(url) {
      const value = String(url || "").trim();
      return (
        /^https?:\/\//i.test(value) &&
        /docs\.google\.com\/document/i.test(value)
      );
    },
    viewFile() {
      const url = this.contentTab.path || this.estimatedArticleRequest?.path || "";
      if (!url) return;
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus();
      }
    },
    async download(id) {
      this.$parent.loading = true;
      try {
        const response = await this.$store.dispatch(
          "Link/downloadDataAction",
          id
        );
        let blob = new Blob([response], {
          type: "application/msword",
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = this.contentTab.filename;
        link.click();
        this.$parent.loading = false;
      } catch (error) {
        this.$parent.loading = false;
        this.errors = error.response.data.errors;
      }
    },

    async revision(id) {
      if (
        this.contentData.reason_id == null ||
        this.contentData.reason_id == "null"
      ) {
        this.errors["reason"] = "Please select a reason";
      }
      if (this.contentData.additional_details == "") {
        this.errors["additional_details"] = "Please fill details";
      } else {
        this.contentData["id"] = id;
        this.$parent.loading = true;
        try {
          let res = await this.$store.dispatch(
            "Link/revisionDataAction",
            this.contentData,
            {
              root: true,
            }
          );
          if (res.success) {
            this.$parent.loading = false;
            toast.success(res.message, { timeout: 3000 });
            // jquery(".btn-close").trigger("click");
              setTimeout(() => {
                window.location = window.location.origin + '/order';
              }, 500);
          }
        } catch (error) {
          this.$parent.loading = false;
          this.errors = error.response.data.errors;
        }
      }
    },

    async approve(id) {
      this.$parent.loading = true;
      try {
        let res = await this.$store.dispatch("Link/approveDataAction", id);
        if (res.success) {
          this.$parent.loading = false;
          toast.success(res.message, { timeout: 3000 });
          setTimeout(() => {
            let currentURL = window.location.href;
            // Create a URL object
            let url = new URL(currentURL);
            // Remove the 'tab' parameter
            url.searchParams.delete('tab');
            window.location = url.href;
          }, 2000);
        }
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },

    async messageRead(id) {
      if(this.messageAlreadyRead == false){
        try {
          let res = await this.$store.dispatch("Dashboard/messageReadDataAction", id);
            if(res.success){
              this.messageAlreadyRead = true;
            }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  computed: {
    isBrandMention() {
      return this.links?.order_type === 'brand_mention';
    },
    includeHyperlinkLabel() {
      const value = this.links?.include_hyperlink ?? this.links?.includeHyperlink;
      const normalized = String(value ?? "").toLowerCase().trim();
      const yes = value === true || value === 1 || value === "1"
        || ["true", "yes", "yes - add a link"].includes(normalized);
      return yes ? "Yes" : "No";
    },
    brandBriefFields() {
      if (!this.isBrandMention) return [];
      return [
        { label: "USP", value: this.links?.usp },
        { label: "Target Query", value: this.links?.target_query },
        { label: "Brand Description", value: this.links?.brand_description },
      ].filter((field) => String(field.value || "").trim() !== "");
    },
    brandBriefRows() {
      const rows = [];
      const perRow = 2;
      for (let i = 0; i < this.brandBriefFields.length; i += perRow) {
        rows.push(this.brandBriefFields.slice(i, i + perRow));
      }
      return rows;
    },
    isGoogleDocArticle() {
      const path = this.contentTab.path || this.estimatedArticleRequest?.path || "";
      return this.isGoogleDocLink(path);
    },
    displayAddons() {
      if (!Array.isArray(this.links?.addons)) return [];
      return this.links.addons.filter((addon) => {
        const name = String(addon?.name || "").trim();
        const value = String(addon?.value || "").trim();
        return !!name && !!value;
      }).map((addon) => ({
        ...addon,
        value: this.formatAddonValue(addon),
      }));
    },
    addonRows() {
      const rows = [];
      const perRow = 3;
      for (let i = 0; i < this.displayAddons.length; i += perRow) {
        rows.push(this.displayAddons.slice(i, i + perRow));
      }
      return rows;
    },
  },
};
</script>

<style scoped>
.link-detail-message-box .recent-box-sec {
  width: 100%;
  box-sizing: border-box;
  padding: 22px 22px 9px;
  border-radius: 15px;
  margin: 0 0 30px;
  background-color: #fff;
  border: 1px solid #edf0f7;
}

.link-detail-message-box .link-detail-message-list {
  width: 100%;
  max-height: 253px;
  overflow-y: auto;
  padding-right: 15px;
}

.link-detail-message-box .link-detail-message-item {
  width: 100%;
  box-sizing: border-box;
  padding: 17px 12px 14px;
  border: 1px solid #edf0f7;
  border-radius: 10px;
  margin-bottom: 14px;
  background-color: #fff;
}

.link-detail-message-box .link-detail-message-item:nth-child(even) {
  background-color: #f7f8fa;
}

.link-detail-message-box .link-detail-message-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 4px;
}

.link-detail-message-box .link-detail-message-name {
  font-weight: bold;
  color: #000000;
  font-size: 14px;
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.link-detail-message-box .link-detail-message-date {
  color: #afb1bb;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

.link-detail-message-box .link-detail-message-text {
  color: #6f7285;
  font-size: 14px;
  word-break: break-word;
}
</style>

<style>
.detail-list-box .detail-table-box table tr.brand-brief-row {
  vertical-align: top;
}

.detail-list-box .detail-table-box table tr.brand-brief-row td .text-1 {
  width: 290px;
  max-width: 100%;
}

.detail-list-box .detail-table-box table tr.brand-brief-row td .text-1 span.brand-brief-text {
  display: block;
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  width: 100%;
}
</style>
